import { render, staticRenderFns } from "./hairInformation.vue?vue&type=template&id=07b4aa62&"
import script from "./hairInformation.vue?vue&type=script&lang=js&"
export * from "./hairInformation.vue?vue&type=script&lang=js&"
import style0 from "./hairInformation.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports